export default __webpack_public_path__ + "static/secure-push-m-57912ab92d24151b2483bf0062f4a65f.webp";